var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated revealUp"},[_c('div',{staticClass:"white-wrapper"},[_c('div',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t("Daily Sales Records")))]),_vm._v(" "),_c('div',{staticClass:"mt-3 mb-4 border-bottom"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-xl-3 align-self-center mb-3"},[_c('div',{staticClass:"input-material"},[_c('div',{staticClass:"add-datepicker"},[(_vm.getDailyReportFromDate)?_c('button',{staticClass:"btn-clearDate",on:{"click":function($event){$event.preventDefault();return _vm.onDailyReportDateHandler({ event: null, name: 'fromDate' })}}},[_vm._v("\n                ✖\n              ")]):_vm._e(),_vm._v(" "),_c('Datepicker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"programaticOpen",attrs:{"monday-first":true,"value":_vm.getDailyReportFromDate,"typeable":""},on:{"selected":function($event){return _vm.onDailyReportDateHandler({
                    event: $event,
                    name: 'fromDate',
                  })}}}),_vm._v(" "),_c('label',{class:_vm.getDailyReportFromDate ? 'active' : ''},[_vm._v(_vm._s(_vm.$t("transactions"))+" "+_vm._s(_vm.$t("date")))])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-xl-3 align-self-center mb-3"},[_c('div',{staticClass:"input-material"},[_c('div',{staticClass:"add-datepicker"},[(_vm.getDailyReportToDate)?_c('button',{staticClass:"btn-clearDate",on:{"click":function($event){return _vm.onDailyReportDateHandler({ event: null, name: 'toDate' })}}},[_vm._v("\n                ✖\n              ")]):_vm._e(),_vm._v(" "),_c('Datepicker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"programaticOpen",attrs:{"monday-first":true,"value":_vm.getDailyReportToDate},on:{"selected":function($event){return _vm.onDailyReportDateHandler({ event: $event, name: 'toDate' })}}}),_vm._v(" "),_c('label',{class:_vm.getDailyReportToDate ? 'active' : ''},[_vm._v("End Date")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-xl-3 align-self-center mb-3"},[_c('div',{staticClass:"dropdown-curve-container mr-2"},[_c('label',{class:_vm.getDailyReportSelectedCinema &&
                _vm.getDailyReportSelectedCinema.length > 0
                  ? 'shift-up'
                  : ''},[_vm._v(_vm._s(_vm.$tc("cinema", 1)))]),_vm._v(" "),_c('b-dropdown',{staticClass:"w-100",attrs:{"text":_vm.getDailyReportSelectedCinema,"variant":"dropdown-curve","disabled":_vm.isRoleID}},[_c('div',{staticClass:"px-2 pb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCinema),expression:"searchCinema"}],staticClass:"form-control form-control-sm",attrs:{"required":"","autofocus":"","type":"search","placeholder":_vm.$tc('searchCinema')},domProps:{"value":(_vm.searchCinema)},on:{"keyup":function($event){return _vm.onSearchCinema()},"keydown":function($event){return _vm.onSearchCinema()},"search":function($event){return _vm.onSearchCinema()},"input":function($event){if($event.target.composing){ return; }_vm.searchCinema=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.Cinemas),function(dropdownItem,dropdownIndex){return _c('b-dropdown-item',{key:dropdownIndex,on:{"click":function($event){_vm.onDailyReportDropdownHandler({
                    event: $event,
                    name: 'Cinema',
                    selectedItem: dropdownItem,
                    index: dropdownIndex,
                  });
                  _vm.searchCinema = '';
                  _vm.onSearchCinema();
                  _vm.onSelectCinema(dropdownItem);}}},[_vm._v(_vm._s(dropdownItem.cine_name))])})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-xl-3 align-self-center mb-3"},[_c('div',{staticClass:"dropdown-curve-container mr-2"},[_c('label',{class:_vm.getDailyReportSelectedPosUser &&
                _vm.getDailyReportSelectedPosUser.length > 0
                  ? 'shift-up'
                  : 'd-none'},[_vm._v(_vm._s(_vm.$tc("user", 1)))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.getPosUsersList,"searchable":true,"placeholder":_vm.getDailyReportSelectedPosUser &&
                _vm.getDailyReportSelectedPosUser.length > 0
                  ? _vm.getDailyReportSelectedPosUser
                  : 'User',"customLabel":_vm.setLabel,"track-by":"user_id","allowEmpty":false,"showLabels":false},on:{"select":function($event){return _vm.onDailyReportDropdownHandler({
                  event: $event,
                  name: 'PosUser',
                  selectedItem: $event,
                })}}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-xl-3 align-self-center mb-3"},[_c('div',{staticClass:"dropdown-curve-container mr-2"},[_c('label',{class:_vm.getDailyReportSelectedPaymentMode &&
                _vm.getDailyReportSelectedPaymentMode.length > 0
                  ? 'shift-up'
                  : ''},[_vm._v(_vm._s(_vm.$t("paymentmode")))]),_vm._v(" "),_c('b-dropdown',{staticClass:"w-100",attrs:{"text":_vm.getDailyReportSelectedPaymentMode,"variant":"dropdown-curve"}},_vm._l((_vm.getPaymentTypesList),function(dropdownItem,dropdownIndex){return _c('b-dropdown-item',{key:dropdownIndex,on:{"click":function($event){return _vm.onDailyReportDropdownHandler({
                    event: $event,
                    name: 'PaymentMode',
                    selectedItem: dropdownItem,
                    index: dropdownIndex,
                  })}}},[_vm._v(_vm._s(dropdownItem.pm_payment_mode))])}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-xl-3 align-self-center mb-3"},[_c('button',{staticClass:"btn-blue-lg w-100",on:{"click":function($event){return _vm.onFetchReport()}}},[_vm._v("\n            "+_vm._s(_vm.$t("fetch"))+" "+_vm._s(_vm.$t("report"))+"\n          ")])]),_vm._v(" "),(
            _vm.getDailyReportList.length > 0 ||
              // getDailyConcessionReportList.length > 0 ||
              _vm.getConcessionDailyReportData.length > 0
          )?_c('div',{staticClass:"col-lg-6 col-xl-6 align-self-center mb-3 d-flex justify-content-end align-items-center"},[(
              _vm.getDailyReportList.length > 0 ||
                // getDailyConcessionReportList.length > 0 ||
                _vm.getConcessionDailyReportData.length > 0
            )?_c('div',[_vm._v(_vm._s(_vm.$t("download"))+" as:")]):_vm._e(),_vm._v(" "),(_vm.getDailyPDFFileName)?_c('a',{attrs:{"href":_vm.BASE_URL + _vm.getDailyPDFFileName,"target":"_blank","download":"","title":"Download as PDF"}},[_c('img',{attrs:{"src":require("@/assets/img/icons/pdf-icon.svg"),"height":"25","width":"25"}})]):_vm._e(),_vm._v(" "),(_vm.getDailyExcelFileName)?_c('a',{attrs:{"href":_vm.BASE_URL + _vm.getDailyExcelFileName,"target":"_blank","title":"Download as Excel","download":""}},[_c('img',{attrs:{"src":require("@/assets/img/icons/excel.svg"),"height":"25","width":"25"}})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 align-self-center"})])]),_vm._v(" "),_c('div',{staticClass:"swc-report"},[_c('table',{staticClass:"swc-report-table dailysales_report",staticStyle:{"table-layout":"auto"},attrs:{"border":"1"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"bg-lightgrey text-left"},[_vm._v(_vm._s("Channel"))]),_vm._v(" "),_c('th',{staticClass:"bg-lightgrey text-left"},[_vm._v(_vm._s("User"))]),_vm._v(" "),_c('th',{staticClass:"bg-lightgrey text-left"},[_vm._v(_vm._s("Location"))]),_vm._v(" "),_c('th',{staticClass:"bg-lightgrey text-left"},[_vm._v("\n              "+_vm._s("PayType")+"\n            ")]),_vm._v(" "),_c('th',{staticClass:"bg-lightgrey text-left"},[_vm._v("\n              "+_vm._s("Vouchers")+"\n            ")]),_vm._v(" "),_c('th',{staticClass:"bg-lightgrey text-right"},[_vm._v("\n              "+_vm._s("#Tix")+"\n            ")]),_vm._v(" "),_c('th',{staticClass:"bg-lightgrey text-right"},[_vm._v("\n              "+_vm._s("Cash")+"\n            ")]),_vm._v(" "),_c('th',{staticClass:"bg-lightgrey text-right"},[_vm._v("\n              "+_vm._s("CreditCard")+"\n            ")]),_vm._v(" "),_c('th',{staticClass:"bg-lightgrey text-right"},[_vm._v(_vm._s("Voucher Amt."))]),_vm._v(" "),_c('th',{staticClass:"bg-lightgrey text-right"},[_vm._v("\n              "+_vm._s(_vm.$t("CashCard"))+"\n            ")]),_vm._v(" "),_c('th',{staticClass:"bg-lightgrey text-right"},[_vm._v("\n              "+_vm._s("Total Sales")+"\n            ")]),_vm._v(" "),_c('th',{staticClass:"bg-lightgrey text-right"},[_c('span',{staticClass:"fs-12"},[_vm._v(_vm._s("Total Sales"))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"fs-10 text-truncate"},[_vm._v(_vm._s("(Less discount)"))])])])]),_vm._v(" "),(
            _vm.getDailyReportList.length === 0 &&
              _vm.getDailyConcessionReportList.length === 0
          )?_c('tbody',[_c('tr',{attrs:{"rowspan":"12"}},[_c('td',{attrs:{"colspan":"12"}},[_c('NoRecords')],1)])]):_vm._e(),_vm._v(" "),_vm._l((_vm.getDailyReportList),function(dailyReportItem,dailyReportItemIndex){return _c('tbody',{key:dailyReportItemIndex},[_c('tr',[_c('td',{staticStyle:{"text-align":"left"},attrs:{"rowspan":"50"}},[_c('strong',[_vm._v(_vm._s(dailyReportItem.Data[0].bs_source))])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-left",attrs:{"rowspan":"50"}},[_c('strong',[_vm._v(_vm._s(dailyReportItem.Data[0].booking_user_name)+" "),_c('br'),_vm._v("("+_vm._s(dailyReportItem.Data[0].up_employee_code)+")")])])]),_vm._v(" "),_c('tr',{staticStyle:{"background-color":"rgba(169, 217, 251, 0.5)"}},[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v(_vm._s(dailyReportItem.Data[0].bs_source))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]),_vm._v(" "),_vm._l((dailyReportItem.Data),function(paymentMode,paymentModeIndex){return _c('tr',{key:paymentModeIndex + paymentMode.tickets},[_c('td'),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(paymentMode.payment_mode))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v("\n              "+_vm._s(paymentMode.offer_name != "" && paymentMode.offer_name != null
                  ? paymentMode.offer_name
                  : paymentMode.voucher_name != "" &&
                    paymentMode.voucher_name != null
                  ? paymentMode.voucher_name
                  : "")+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(paymentMode.tickets))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(paymentMode.cash_amount))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(paymentMode.payment_mode_amount))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.currFormat(paymentMode.discount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(paymentMode.cash_card_amount))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(paymentMode.gross_amount))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(paymentMode.gross_revenue))+"\n            ")])])}),_vm._v(" "),_c('tr',{staticStyle:{"background-color":"rgba(211, 211, 211, 0.4)"}},[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v(_vm._s(dailyReportItem.Data[0].bs_source)+"\n                "+_vm._s(_vm.$t("total")))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(dailyReportItem.Data.reduce(function(
                  accumulator,
                  ref
                ) {
                  var tickets = ref.tickets;

                  return accumulator + parseFloat(tickets);
                },
                0)))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.Data.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var cash_amount = ref.cash_amount;

                    return accumulator + parseFloat(cash_amount);
                  },
                  0)
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.Data.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var payment_mode_amount = ref.payment_mode_amount;

                    return accumulator + parseFloat(payment_mode_amount);
                  },
                  0)
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.Data.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var discount = ref.discount;

                    return accumulator + parseFloat(discount);
                  },
                  0)
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.Data.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var cash_card_amount = ref.cash_card_amount;

                    return accumulator + parseFloat(cash_card_amount);
                  },
                  0)
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.Data.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var gross_amount = ref.gross_amount;

                    return accumulator + parseFloat(gross_amount);
                  },
                  0)
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.Data.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var gross_revenue = ref.gross_revenue;

                    return accumulator + parseFloat(gross_revenue);
                  },
                  0)
                )))])])]),_vm._v(" "),(dailyReportItem.DataRefund)?_c('tr',{staticStyle:{"background-color":"rgba(246, 194, 188, 0.5)"}},[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v(_vm._s(_vm.$tc("refund", 1)))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]):_c('tr'),_vm._v(" "),_vm._l((dailyReportItem.DataRefund),function(paymentMode1,paymentMode1Index){return _c('tr',{key:paymentMode1Index + paymentMode1.payment_mode},[_c('td'),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(paymentMode1.payment_mode))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v("\n              "+_vm._s(paymentMode1.offer_name != "" || null
                  ? paymentMode1.offer_name
                  : paymentMode1.voucher_name != "" || null
                  ? paymentMode1.voucher_name
                  : "")+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("-"+_vm._s(paymentMode1.tickets))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(paymentMode1.cash_amount_refund) > 0
                  ? "-" + _vm.currFormat(paymentMode1.cash_amount_refund)
                  : _vm.currFormat(paymentMode1.cash_amount_refund))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(paymentMode1.payment_mode_amount_refund) > 0
                  ? "-" + _vm.currFormat(paymentMode1.payment_mode_amount_refund)
                  : _vm.currFormat(paymentMode1.payment_mode_amount_refund))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(paymentMode1.discount) > 0
                  ? "-" + _vm.currFormat(paymentMode1.discount)
                  : _vm.currFormat(paymentMode1.discount))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(paymentMode1.cash_card_refund) > 0
                  ? "-" + _vm.currFormat(paymentMode1.cash_card_refund)
                  : _vm.currFormat(paymentMode1.cash_card_refund))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(paymentMode1.gross_amount) > 0
                  ? "-" + _vm.currFormat(paymentMode1.gross_amount)
                  : _vm.currFormat(paymentMode1.gross_amount))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(paymentMode1.gross_revenue) > 0
                  ? "-" + _vm.currFormat(paymentMode1.gross_revenue)
                  : _vm.currFormat(paymentMode1.gross_revenue))+"\n            ")])])}),_vm._v(" "),(dailyReportItem.DataRefund)?_c('tr',{staticStyle:{"background-color":"rgba(211, 211, 211, 0.4)"}},[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v(_vm._s(_vm.$tc("refund", 2))+" "+_vm._s(_vm.$t("total")))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(dailyReportItem.DataRefund.reduce(function(
                  accumulator,
                  ref
                ) {
                  var tickets = ref.tickets;

                  return accumulator + parseFloat(tickets);
                },
                0) > 0
                  ? "-" +
                    dailyReportItem.DataRefund.reduce(function(
                      accumulator,
                      ref
                    ) {
                      var tickets = ref.tickets;

                      return accumulator + parseFloat(tickets);
                    },
                    0)
                  : dailyReportItem.DataRefund.reduce(function(
                      accumulator,
                      ref
                    ) {
                      var tickets = ref.tickets;

                      return accumulator + parseFloat(tickets);
                    },
                    0)))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.DataRefund.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var cash_amount_refund = ref.cash_amount_refund;

                    return accumulator + parseFloat(cash_amount_refund);
                  },
                  0)
                ) > 0
                  ? "-" +
                    _vm.currFormat(
                      dailyReportItem.DataRefund.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var cash_amount_refund = ref.cash_amount_refund;

                        return accumulator + parseFloat(cash_amount_refund);
                      },
                      0)
                    )
                  : _vm.currFormat(
                      dailyReportItem.DataRefund.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var cash_amount_refund = ref.cash_amount_refund;

                        return accumulator + parseFloat(cash_amount_refund);
                      },
                      0)
                    )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.DataRefund.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var payment_mode_amount_refund = ref.payment_mode_amount_refund;

                    return (
                      accumulator + parseFloat(payment_mode_amount_refund)
                    );
                  },
                  0)
                ) > 0
                  ? "-" +
                    _vm.currFormat(
                      dailyReportItem.DataRefund.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var payment_mode_amount_refund = ref.payment_mode_amount_refund;

                        return (
                          accumulator + parseFloat(payment_mode_amount_refund)
                        );
                      },
                      0)
                    )
                  : _vm.currFormat(
                      dailyReportItem.DataRefund.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var payment_mode_amount_refund = ref.payment_mode_amount_refund;

                        return (
                          accumulator + parseFloat(payment_mode_amount_refund)
                        );
                      },
                      0)
                    )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.DataRefund.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var discount = ref.discount;

                    return accumulator + parseFloat(discount);
                  },
                  0)
                ) > 0
                  ? "-" +
                    _vm.currFormat(
                      dailyReportItem.DataRefund.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var discount = ref.discount;

                        return accumulator + parseFloat(discount);
                      },
                      0)
                    )
                  : _vm.currFormat(
                      dailyReportItem.DataRefund.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var discount = ref.discount;

                        return accumulator + parseFloat(discount);
                      },
                      0)
                    )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.DataRefund.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var cash_card_refund = ref.cash_card_refund;

                    return accumulator + parseFloat(cash_card_refund);
                  },
                  0)
                ) > 0
                  ? "-" +
                    _vm.currFormat(
                      dailyReportItem.DataRefund.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var cash_card_refund = ref.cash_card_refund;

                        return accumulator + parseFloat(cash_card_refund);
                      },
                      0)
                    )
                  : _vm.currFormat(
                      dailyReportItem.DataRefund.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var cash_card_refund = ref.cash_card_refund;

                        return accumulator + parseFloat(cash_card_refund);
                      },
                      0)
                    )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.DataRefund.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var gross_amount = ref.gross_amount;

                    return accumulator + parseFloat(gross_amount);
                  },
                  0)
                ) > 0
                  ? "-" +
                    _vm.currFormat(
                      dailyReportItem.DataRefund.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var gross_amount = ref.gross_amount;

                        return accumulator + parseFloat(gross_amount);
                      },
                      0)
                    )
                  : _vm.currFormat(
                      dailyReportItem.DataRefund.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var gross_amount = ref.gross_amount;

                        return accumulator + parseFloat(gross_amount);
                      },
                      0)
                    )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.DataRefund.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var gross_revenue = ref.gross_revenue;

                    return accumulator + parseFloat(gross_revenue);
                  },
                  0)
                ) > 0
                  ? "-" +
                    _vm.currFormat(
                      dailyReportItem.DataRefund.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var gross_revenue = ref.gross_revenue;

                        return accumulator + parseFloat(gross_revenue);
                      },
                      0)
                    )
                  : _vm.currFormat(
                      dailyReportItem.DataRefund.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var gross_revenue = ref.gross_revenue;

                        return accumulator + parseFloat(gross_revenue);
                      },
                      0)
                    )))])])]):_c('tr'),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v(_vm._s(dailyReportItem.Data[0].bs_source)+" "+_vm._s(_vm.$t("final"))+"\n                "+_vm._s(_vm.$t("total")))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(dailyReportItem.DataRefund
                  ? dailyReportItem.Data.reduce(function(
                      accumulator,
                      ref
                    ) {
                      var tickets = ref.tickets;

                      return accumulator + parseFloat(tickets);
                    },
                    0) -
                    dailyReportItem.DataRefund.reduce(function(
                      accumulator,
                      ref
                    ) {
                      var tickets = ref.tickets;

                      return accumulator + parseFloat(tickets);
                    },
                    0)
                  : dailyReportItem.Data.reduce(function(
                      accumulator,
                      ref
                    ) {
                      var tickets = ref.tickets;

                      return accumulator + parseFloat(tickets);
                    },
                    0)))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.DataRefund
                    ? dailyReportItem.Data.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var cash_amount = ref.cash_amount;

                        return accumulator + parseFloat(cash_amount);
                      },
                      0) -
                        dailyReportItem.DataRefund.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var cash_amount_refund = ref.cash_amount_refund;

                          return accumulator + parseFloat(cash_amount_refund);
                        },
                        0)
                    : dailyReportItem.Data.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var cash_amount = ref.cash_amount;

                        return accumulator + parseFloat(cash_amount);
                      },
                      0)
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.DataRefund
                    ? dailyReportItem.Data.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var payment_mode_amount = ref.payment_mode_amount;

                        return accumulator + parseFloat(payment_mode_amount);
                      },
                      0) -
                        dailyReportItem.DataRefund.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var payment_mode_amount_refund = ref.payment_mode_amount_refund;

                          return (
                            accumulator +
                            parseFloat(payment_mode_amount_refund)
                          );
                        },
                        0)
                    : dailyReportItem.Data.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var payment_mode_amount = ref.payment_mode_amount;

                        return accumulator + parseFloat(payment_mode_amount);
                      },
                      0)
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.DataRefund
                    ? _vm.currFormat(
                        dailyReportItem.Data.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var discount = ref.discount;

                          return accumulator + parseFloat(discount);
                        },
                        0) -
                          dailyReportItem.DataRefund.reduce(function(
                            accumulator,
                            ref
                          ) {
                            var discount = ref.discount;

                            return accumulator + parseFloat(discount);
                          },
                          0)
                      )
                    : _vm.currFormat(
                        dailyReportItem.Data.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var discount = ref.discount;

                          return accumulator + parseFloat(discount);
                        },
                        0)
                      )
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.DataRefund
                    ? _vm.currFormat(
                        dailyReportItem.Data.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var cash_card_amount = ref.cash_card_amount;

                          return accumulator + parseFloat(cash_card_amount);
                        },
                        0) -
                          dailyReportItem.DataRefund.reduce(function(
                            accumulator,
                            ref
                          ) {
                            var cash_card_refund = ref.cash_card_refund;

                            return accumulator + parseFloat(cash_card_refund);
                          },
                          0)
                      )
                    : _vm.currFormat(
                        dailyReportItem.Data.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var cash_card_amount = ref.cash_card_amount;

                          return accumulator + parseFloat(cash_card_amount);
                        },
                        0)
                      )
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.DataRefund
                    ? _vm.currFormat(
                        dailyReportItem.Data.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var gross_amount = ref.gross_amount;

                          return accumulator + parseFloat(gross_amount);
                        },
                        0) -
                          dailyReportItem.DataRefund.reduce(function(
                            accumulator,
                            ref
                          ) {
                            var gross_amount = ref.gross_amount;

                            return accumulator + parseFloat(gross_amount);
                          },
                          0)
                      )
                    : _vm.currFormat(
                        dailyReportItem.Data.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var gross_amount = ref.gross_amount;

                          return accumulator + parseFloat(gross_amount);
                        },
                        0)
                      )
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  dailyReportItem.DataRefund
                    ? _vm.currFormat(
                        dailyReportItem.Data.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var gross_revenue = ref.gross_revenue;

                          return accumulator + parseFloat(gross_revenue);
                        },
                        0) -
                          dailyReportItem.DataRefund.reduce(function(
                            accumulator,
                            ref
                          ) {
                            var gross_revenue = ref.gross_revenue;

                            return accumulator + parseFloat(gross_revenue);
                          },
                          0)
                      )
                    : _vm.currFormat(
                        dailyReportItem.Data.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var gross_revenue = ref.gross_revenue;

                          return accumulator + parseFloat(gross_revenue);
                        },
                        0)
                      )
                )))])])])],2)}),_vm._v(" "),_vm._l((_vm.getDailyConcessionReportList),function(DailyConcessionReportItem,DailyConcessionReportItemIndex){return _c('tbody',{key:DailyConcessionReportItemIndex},[_c('tr',[_c('td',{attrs:{"rowspan":"9"}},[_c('strong',[_vm._v(_vm._s(_vm.$t("concession")))])])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"rowspan":"9"}},[_c('strong',[_vm._v(_vm._s(DailyConcessionReportItem.first_name)+" "+_vm._s(DailyConcessionReportItem.last_name))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_vm._v(_vm._s(_vm.$t("concession")))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]),_vm._v(" "),_vm._l((DailyConcessionReportItem.transactions),function(TransactionItem,TransactionIndex){return _c('tr',{key:TransactionIndex},[_c('td'),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(TransactionItem.pm_payment_mode))]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(TransactionItem.number_of_tickets))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(TransactionItem.net_revenue))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("0.00")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(TransactionItem.gross_revenue))+"\n            ")])])}),_vm._v(" "),_c('tr',[_vm._m(0,true),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(_vm.$t("concession")))])]),_vm._v(" "),_vm._m(1,true),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(DailyConcessionReportItem.transactions.reduce(function(
                  accumulator,
                  ref
                ) {
                  var number_of_tickets = ref.number_of_tickets;

                  return accumulator + parseFloat(number_of_tickets);
                },
                0)))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  DailyConcessionReportItem.transactions.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var net_revenue = ref.net_revenue;

                    return accumulator + parseFloat(net_revenue);
                  },
                  0)
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("0.00")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  DailyConcessionReportItem.transactions.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var gross_revenue = ref.gross_revenue;

                    return accumulator + parseFloat(gross_revenue);
                  },
                  0)
                )))])])])],2)}),_vm._v(" "),(_vm.getDailyConcessionReportList.length > 0)?_c('tbody',[_c('tr',[_c('td',{attrs:{"colspan":"5"}},[_c('strong',[_vm._v(_vm._s(_vm.$t("concession")))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(_vm.getConcessionOfficeTotal.totalNumberOfTickets))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(_vm.getConcessionOfficeTotal.totalNetRevenue)))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("0.00")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(_vm.getConcessionOfficeTotal.totalGrossRevenue)))])])])]):_vm._e(),_vm._v(" "),(
            _vm.getDailyConcessionReportList.length > 0 ||
              _vm.getDailyReportList.length > 0
          )?_c('tbody',[_c('tr',[_c('td',{staticClass:"bg-lightgrey text-left",attrs:{"colspan":"2"}},[_c('strong',[_vm._v(_vm._s(_vm.$t("grand"))+" "+_vm._s(_vm.$t("total")))])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('td',{staticClass:"bg-lightgrey text-right"},[_c('strong',[_vm._v(_vm._s(_vm.getGrandTotal.totalNumberOfTickets))])]),_vm._v(" "),_c('td',{staticClass:"bg-lightgrey text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(_vm.getGrandTotal.totalCashAmount)))])]),_vm._v(" "),_c('td',{staticClass:"bg-lightgrey text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(_vm.getGrandTotal.totalPaymentmodeAmount)))])]),_vm._v(" "),_c('td',{staticClass:"bg-lightgrey text-right"},[(_vm.getGrandTotal.totalDiscount)?_c('strong',[_vm._v(_vm._s(_vm.currFormat(_vm.getGrandTotal.totalDiscount)))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"bg-lightgrey text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(_vm.getGrandTotal.totalCashCardAmount)))])]),_vm._v(" "),_c('td',{staticClass:"bg-lightgrey text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(_vm.getGrandTotal.totalGrossAmount)))])]),_vm._v(" "),_c('td',{staticClass:"bg-lightgrey text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(_vm.getGrandTotal.totalGrossRevenue)))])])])]):_vm._e()],2)]),_vm._v(" "),(false)?_c('div',{staticClass:"row mx-0 mt-3 reports-box"},[_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16)]):_vm._e(),_vm._v(" "),(_vm.getCashRefundVoucher.length > 0)?_c('div',{staticClass:"swc-report mt-3"},[_c('table',{staticClass:"swc-report-table",staticStyle:{"table-layout":"auto"},attrs:{"border":"1"}},[_vm._m(17),_vm._v(" "),_c('tbody',[_vm._l((_vm.getCashRefundVoucher),function(UserItem,UserIndex){return _c('tr',{key:UserIndex},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(UserIndex + 1))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(UserItem.outlet))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(UserItem.voucher_name))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(UserItem.voucher_type))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(UserItem.totalVoucherAmount))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(UserItem.t_gross_amount_before_offer))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(UserItem.cash_refund_amount))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(UserItem.pm_payment_mode))])])}),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('td',{staticClass:"text-left",attrs:{"colspan":"4"}},[_c('strong',[_vm._v(_vm._s(_vm.$t("total")))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  _vm.getCashRefundVoucher.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var totalVoucherAmount = ref.totalVoucherAmount;

                    return accumulator + parseFloat(totalVoucherAmount);
                  },
                  0)
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  _vm.getCashRefundVoucher.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var t_gross_amount_before_offer = ref.t_gross_amount_before_offer;

                    return (
                      accumulator + parseFloat(t_gross_amount_before_offer)
                    );
                  },
                  0)
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  _vm.getCashRefundVoucher.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var cash_refund_amount = ref.cash_refund_amount;

                    return accumulator + parseFloat(cash_refund_amount);
                  },
                  0)
                )))])]),_vm._v(" "),_c('td')])],2)])]):_vm._e(),_vm._v(" "),(_vm.getSaleCashCard.length > 0)?_c('div',{staticClass:"swc-report mt-3"},[_c('table',{staticClass:"swc-report-table",staticStyle:{"table-layout":"auto"},attrs:{"border":"1"}},[_vm._m(18),_vm._v(" "),_c('tbody',[_vm._l((_vm.getSaleCashCard),function(UserItem,UserIndex){return _c('tr',{key:UserIndex},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(UserIndex + 1))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(UserItem.cash_Card_issuer))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(UserItem.no_of_cash_card))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(UserItem.payment_value))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(UserItem.processing_fee))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.currFormat(UserItem.total)))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(UserItem.payment_mode_name))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"icon-eye mr-1",on:{"click":function($event){return _vm.showCardList(UserItem)}}})])])}),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('td',{staticClass:"text-left",attrs:{"colspan":"2"}},[_c('strong',[_vm._v(_vm._s(_vm.$t("total")))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.getSaleCashCard.reduce(function(
                  accumulator,
                  ref
                ) {
                  var no_of_cash_card = ref.no_of_cash_card;

                  return accumulator + parseFloat(no_of_cash_card);
                },
                0)))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  _vm.getSaleCashCard.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var processing_fee = ref.processing_fee;

                    return accumulator + parseFloat(processing_fee);
                  },
                  0)
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  _vm.getSaleCashCard.reduce(function(accumulator, ref) {
                    var total = ref.total;

                    return accumulator + parseFloat(total);
                  }, 0)
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"})])],2)])]):_vm._e(),_vm._v(" "),(_vm.getTopUpCashCard.length > 0)?_c('div',{staticClass:"swc-report mt-3"},[_c('table',{staticClass:"swc-report-table",staticStyle:{"table-layout":"auto"},attrs:{"border":"1"}},[_vm._m(19),_vm._v(" "),_c('tbody',[_vm._l((_vm.getTopUpCashCard),function(UserItem,UserIndex){return _c('tr',{key:UserIndex},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(UserIndex + 1))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(UserItem.pm_payment_mode))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.currFormat(UserItem.amount)))])])}),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('td',{staticClass:"text-left",attrs:{"colspan":"2"}},[_c('strong',[_vm._v(_vm._s(_vm.$t("total")))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  _vm.getTopUpCashCard.reduce(function(accumulator, ref) {
                    var amount = ref.amount;

                    return accumulator + parseFloat(amount);
                  }, 0)
                )))])])])],2)])]):_vm._e(),_vm._v(" "),(_vm.getPaymentSummary.length > 0)?_c('div',{staticClass:"swc-report mt-3"},[_c('table',{staticClass:"swc-report-table",staticStyle:{"table-layout":"auto"},attrs:{"border":"1"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"5"}},[_vm._v("\n              "+_vm._s(_vm.$tc("payment", 1))+" "+_vm._s(_vm.$t("type"))+" "+_vm._s(_vm.$t("wise"))+"\n              "+_vm._s(_vm.$t("summary"))+" - "+_vm._s("Tickets/f&b Sales")+"\n            ")])]),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey text-left"},[_c('th',{staticClass:"text-left",attrs:{"rowspan":"2"}},[_vm._v("\n              "+_vm._s("Channel")+"\n            ")]),_vm._v(" "),_c('th',{staticClass:"text-left",attrs:{"rowspan":"2"}},[_vm._v("\n              "+_vm._s("PayType")+"\n            ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t("current"))+" sold")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n              "+_vm._s(_vm.$t("advance"))+" "+_vm._s(_vm.$t("sold"))+" "+_vm._s(_vm.$t("today"))+"\n            ")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"rowspan":"2"}},[_vm._v("Total")])]),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('th',[_c('table',{staticClass:"fixed-layout-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s("Sale")+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s("Refund")+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_c('span',{staticClass:"fs-12"},[_vm._v(_vm._s("Balance"))])])])])])]),_vm._v(" "),_c('th',[_c('table',{staticClass:"fixed-layout-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s("Sale")+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s("Refund")+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_c('span',{staticClass:"fs-12"},[_vm._v(_vm._s("Balance"))])])])])])])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.getPaymentSummary),function(Payment,PaymentIndex){return _c('tr',{key:PaymentIndex},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(Payment.bs_source))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(Payment.pm_payment_mode))]),_vm._v(" "),_c('td',[_c('table',{staticClass:"fixed-layout-table"},[_c('tr',[_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(Payment.payment_mode_amount))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(_vm.getNegativeValue(Payment.refundAmount)))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(Payment.balance))+"\n                  ")])])])]),_vm._v(" "),_c('td',[_c('table',{staticClass:"fixed-layout-table"},[_c('tr',[_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(Payment.advance_payment_mode_amount))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(
                        _vm.getNegativeValue(Payment.advanceRefundAmount)
                      ))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(Payment.advanceBalance))+"\n                  ")])])])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(Payment.balance + Payment.advanceBalance))+"\n            ")])])}),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('td',{staticClass:"text-left",attrs:{"colspan":"2"}},[_c('strong',[_vm._v(_vm._s(_vm.$t("total")))])]),_vm._v(" "),_c('td',[_c('table',{staticClass:"fixed-layout-table"},[_c('tr',[_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(
                        _vm.getPaymentSummary.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var payment_mode_amount = ref.payment_mode_amount;

                          return (
                            accumulator + parseFloat(payment_mode_amount)
                          );
                        },
                        0)
                      ))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(
                        _vm.getNegativeValue(
                          _vm.getPaymentSummary.reduce(function(
                            accumulator,
                            ref
                          ) {
                            var refundAmount = ref.refundAmount;

                            return accumulator + parseFloat(refundAmount);
                          },
                          0)
                        )
                      ))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(
                        _vm.getPaymentSummary.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var balance = ref.balance;

                          return accumulator + parseFloat(balance);
                        },
                        0)
                      ))+"\n                  ")])])])]),_vm._v(" "),_c('td',[_c('table',{staticClass:"fixed-layout-table"},[_c('tr',[_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(
                        _vm.getPaymentSummary.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var advance_payment_mode_amount = ref.advance_payment_mode_amount;

                          return (
                            accumulator +
                            parseFloat(advance_payment_mode_amount)
                          );
                        },
                        0)
                      ))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    -"+_vm._s(_vm.currFormat(
                        _vm.getPaymentSummary.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var advanceRefundAmount = ref.advanceRefundAmount;

                          return (
                            accumulator + parseFloat(advanceRefundAmount)
                          );
                        },
                        0)
                      ))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(
                        _vm.getPaymentSummary.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var advanceBalance = ref.advanceBalance;

                          return accumulator + parseFloat(advanceBalance);
                        },
                        0)
                      ))+"\n                  ")])])])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getPaymentSummary.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var advanceBalance = ref.advanceBalance;
                    var balance = ref.balance;

                    return (
                      accumulator +
                      parseFloat(balance) +
                      parseFloat(advanceBalance)
                    );
                  },
                  0)
                ))+"\n            ")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.getPaymentSummary.length > 0 && false)?_c('div',{staticClass:"swc-report mt-3"},[_c('table',{staticClass:"swc-report-table",staticStyle:{"table-layout":"auto"},attrs:{"border":"1"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"5"}},[_vm._v("\n              "+_vm._s(_vm.$tc("payment", 1))+" "+_vm._s(_vm.$t("type"))+" "+_vm._s(_vm.$t("wise"))+"\n              "+_vm._s(_vm.$t("summary"))+"\n            ")])]),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey text-left"},[_c('th',{staticClass:"text-left",attrs:{"rowspan":"2"}},[_vm._v("\n              "+_vm._s("Channel")+"\n            ")]),_vm._v(" "),_c('th',{staticClass:"text-left",attrs:{"rowspan":"2"}},[_vm._v("\n              "+_vm._s("PayType")+"\n            ")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("current"))+" sold")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("advance"))+" "+_vm._s(_vm.$t("sold"))+" "+_vm._s(_vm.$t("today")))]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"rowspan":"2"}},[_vm._v("Total")])]),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('th',[_c('table',{staticClass:"fixed-layout-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.$tc("ticket", 1)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.$tc("Payment Mode Amount", 1))+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.$tc("Cash Card Amount", 1))+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_c('span',{staticClass:"fs-12"},[_vm._v(_vm._s("Total Sales"))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"fs-10 text-truncate"},[_vm._v(_vm._s("(Less discount)"))])])])])])]),_vm._v(" "),_c('th',[_c('table',{staticClass:"fixed-layout-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.$tc("ticket", 1)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.$tc("Payment Mode Amount", 1))+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.$tc("Cash Card Amount", 1))+"\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_c('span',{staticClass:"fs-12"},[_vm._v(_vm._s("Total Sales"))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"fs-10 text-truncate"},[_vm._v(_vm._s("(Less discount)"))])])])])])])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.getPaymentSummary),function(Payment,PaymentIndex){return _c('tr',{key:PaymentIndex},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(Payment.bs_source))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(Payment.pm_payment_mode))]),_vm._v(" "),_c('td',[_c('table',{staticClass:"fixed-layout-table"},[_c('tr',[_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(Payment.tickets))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(Payment.payment_mode_amount))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(Payment.cash_card_amount))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(Payment.gross_amount))+"\n                  ")])])])]),_vm._v(" "),_c('td',[_c('table',{staticClass:"fixed-layout-table"},[_c('tr',[_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(Payment.advanceTickets))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(Payment.advance_payment_mode_amount))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(Payment.advance_cash_card_amount))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(Payment.advanceGrossAmount))+"\n                  ")])])])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(Payment.gross_amount + Payment.advanceGrossAmount))+"\n            ")])])}),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('td',{staticClass:"text-left",attrs:{"colspan":"2"}},[_c('strong',[_vm._v(_vm._s(_vm.$t("total")))])]),_vm._v(" "),_c('td',[_c('table',{staticClass:"fixed-layout-table"},[_c('tr',[_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.getPaymentSummary.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var tickets = ref.tickets;

                        return accumulator + parseFloat(tickets);
                      },
                      0))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(
                        _vm.getPaymentSummary.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var payment_mode_amount = ref.payment_mode_amount;

                          return (
                            accumulator + parseFloat(payment_mode_amount)
                          );
                        },
                        0)
                      ))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(
                        _vm.getPaymentSummary.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var cash_card_amount = ref.cash_card_amount;

                          return accumulator + parseFloat(cash_card_amount);
                        },
                        0)
                      ))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(
                        _vm.getPaymentSummary.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var gross_amount = ref.gross_amount;

                          return accumulator + parseFloat(gross_amount);
                        },
                        0)
                      ))+"\n                  ")])])])]),_vm._v(" "),_c('td',[_c('table',{staticClass:"fixed-layout-table"},[_c('tr',[_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.getPaymentSummary.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var advanceTickets = ref.advanceTickets;

                        return accumulator + parseFloat(advanceTickets);
                      },
                      0))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(
                        _vm.getPaymentSummary.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var advance_payment_mode_amount = ref.advance_payment_mode_amount;

                          return (
                            accumulator +
                            parseFloat(advance_payment_mode_amount)
                          );
                        },
                        0)
                      ))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(
                        _vm.getPaymentSummary.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var advance_cash_card_amount = ref.advance_cash_card_amount;

                          return (
                            accumulator + parseFloat(advance_cash_card_amount)
                          );
                        },
                        0)
                      ))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(
                        _vm.getPaymentSummary.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var advanceGrossAmount = ref.advanceGrossAmount;

                          return accumulator + parseFloat(advanceGrossAmount);
                        },
                        0)
                      ))+"\n                  ")])])])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getPaymentSummary.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var advanceGrossAmount = ref.advanceGrossAmount;
                    var gross_amount = ref.gross_amount;

                    return (
                      accumulator +
                      parseFloat(gross_amount) +
                      parseFloat(advanceGrossAmount)
                    );
                  },
                  0)
                ))+"\n            ")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.getFilmSummary.length > 0)?_c('div',{staticClass:"swc-report mt-3"},[_c('table',{staticClass:"swc-report-table",staticStyle:{"table-layout":"auto"},attrs:{"border":"1"}},[_c('thead',[_vm._m(20),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('th',{staticClass:"text-left",attrs:{"rowspan":"2"}},[_vm._v("Movie")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.$t("current")))]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("\n              "+_vm._s(_vm.$t("advance"))+" "+_vm._s(_vm.$t("sold"))+" "+_vm._s(_vm.$t("today"))+"\n            ")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"rowspan":"2"}},[_vm._v("Total")])]),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('th',[_c('table',{staticClass:"fixed-layout-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.$tc("ticket", 1)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_c('span',{staticClass:"fs-12"},[_vm._v(_vm._s("Total Sales"))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"fs-10 text-truncate"},[_vm._v(_vm._s("(Less discount)"))])])])])])]),_vm._v(" "),_c('th',[_c('table',{staticClass:"fixed-layout-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.$tc("ticket", 1)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_c('span',{staticClass:"fs-12"},[_vm._v(_vm._s("Total Sales"))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"fs-10 text-truncate"},[_vm._v(_vm._s("(Less discount)"))])])])])])])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.getFilmSummary),function(filmItem,filmIndex){return _c('tr',{key:filmIndex},[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v(_vm._s(filmItem.movie))])]),_vm._v(" "),_c('td',{staticClass:"p-0"},[_c('table',{staticClass:"fixed-layout-table"},[_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(filmItem.ticket))]),_vm._v(" "),_c('td',{staticClass:"text-left p-0"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(filmItem.gross_amount))+"\n                  ")])])])]),_vm._v(" "),_c('td',[_c('table',{staticClass:"fixed-layout-table"},[_c('tr',[_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(filmItem.advanceTickets))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm.currFormat(filmItem.advanceGrossAmount))+"\n                  ")])])])]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  filmItem.gross_amount + filmItem.advanceGrossAmount
                ))+"\n            ")])])}),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v(_vm._s(_vm.$t("total")))])]),_vm._v(" "),_c('td',[_c('table',{staticClass:"fixed-layout-table"},[_c('tr',[_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.getFilmSummary.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var ticket = ref.ticket;

                        return accumulator + parseFloat(ticket);
                      },
                      0)))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                        _vm.getFilmSummary.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var gross_amount = ref.gross_amount;

                          return accumulator + parseFloat(gross_amount);
                        },
                        0)
                      )))])])])])]),_vm._v(" "),_c('td',[_c('table',{staticClass:"fixed-layout-table"},[_c('tr',[_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.getFilmSummary.reduce(function(
                        accumulator,
                        ref
                      ) {
                        var advanceTickets = ref.advanceTickets;

                        return accumulator + parseFloat(advanceTickets);
                      },
                      0)))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                        _vm.getFilmSummary.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var advanceGrossAmount = ref.advanceGrossAmount;

                          return accumulator + parseFloat(advanceGrossAmount);
                        },
                        0)
                      )))])])])])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  _vm.getFilmSummary.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var advanceGrossAmount = ref.advanceGrossAmount;
                    var gross_amount = ref.gross_amount;

                    return (
                      accumulator +
                      parseFloat(advanceGrossAmount) +
                      parseFloat(gross_amount)
                    );
                  },
                  0)
                )))])])])],2)])]):_vm._e(),_vm._v(" "),(_vm.getUserWiseSummary.length > 0)?_c('div',{staticClass:"swc-report mt-3"},[_c('table',{staticClass:"swc-report-table",staticStyle:{"table-layout":"auto"},attrs:{"border":"1"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"6"}},[_vm._v("\n              "+_vm._s(_vm.$tc("user"))+" "+_vm._s(_vm.$tc("wise"))+" "+_vm._s(_vm.$tc("summary"))+"\n            ")])]),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('th',{staticClass:"text-left"},[_vm._v(_vm._s("Channel"))]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.$tc("user", 1)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.$t("current")))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.$t("advance"))+" "+_vm._s(_vm.$t("sold"))+" "+_vm._s(_vm.$t("today"))+"\n            ")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.$t("total")))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.getUserWiseSummary),function(UserItem,UserIndex){return _c('tr',{key:UserIndex},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(UserItem.bs_source))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(UserItem.booking_user_name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(UserItem.gross_amount))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(UserItem.advanceGrossAmount))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  UserItem.advanceGrossAmount + UserItem.gross_amount
                ))+"\n            ")])])}),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('td',{staticClass:"text-left",attrs:{"colspan":"2"}},[_c('strong',[_vm._v(_vm._s(_vm.$t("total")))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  _vm.getUserWiseSummary.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var gross_amount = ref.gross_amount;

                    return accumulator + parseFloat(gross_amount);
                  },
                  0)
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  _vm.getUserWiseSummary.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var advanceGrossAmount = ref.advanceGrossAmount;

                    return accumulator + parseFloat(advanceGrossAmount);
                  },
                  0)
                )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  _vm.getUserWiseSummary.reduce(function(
                    accumulator,
                    ref
                  ) {
                    var gross_amount = ref.gross_amount;
                    var advanceGrossAmount = ref.advanceGrossAmount;

                    return (
                      accumulator +
                      (parseFloat(advanceGrossAmount) +
                        parseFloat(gross_amount))
                    );
                  },
                  0)
                )))])])])],2)])]):_vm._e(),_vm._v(" "),(_vm.getRefundSummary.length > 0)?_c('div',{staticClass:"swc-report mt-3"},[_c('table',{staticClass:"swc-report-table",staticStyle:{"table-layout":"auto"},attrs:{"border":"1"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"5"}},[_vm._v("\n              "+_vm._s(_vm.$tc("refund", 1))+" "+_vm._s(_vm.$t("summary"))+" - "+_vm._s("Tickets")+"\n            ")])]),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('th',{staticClass:"text-left"},[_vm._v(_vm._s("Channel"))]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.$tc("user", 1)))]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s("PayType"))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.$tc("ticket", 1)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.$tc("refund", 1))+" "+_vm._s(_vm.$t("value"))+"\n            ")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.getRefundSummary),function(RefundItem,RefundIndex){return _c('tr',{key:RefundIndex},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(RefundItem.bs_source))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(RefundItem.username))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(RefundItem.pm_payment_mode))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(RefundItem.tickets))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.currFormat(RefundItem.refund)))])])}),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v(_vm._s(_vm.$t("total")))])]),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.getRefundSummary.reduce(function(accumulator, ref) {
                  var tickets = ref.tickets;

                  return accumulator + parseFloat(tickets);
                }, 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                  _vm.getRefundSummary.reduce(function(accumulator, ref) {
                    var refund = ref.refund;

                    return accumulator + parseFloat(refund);
                  }, 0)
                )))])])])],2)])]):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"swc-report mt-3"},[_c('table',{staticClass:"swc-report-table",staticStyle:{"table-layout":"auto"},attrs:{"border":"1"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"4"}},[_vm._v("\n              "+_vm._s(_vm.$t("advance"))+" "+_vm._s(_vm.$t("sold"))+" "+_vm._s(_vm.$t("today"))+"'s\n              (20-Sep-2019) "+_vm._s(_vm.$t("show"))+"\n            ")])]),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.$t("outlet")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$tc("payment", 1))+" "+_vm._s(_vm.$tc("type", 1)))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$tc("ticket", 1)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.$t("rrevenue")))])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.$t("boxoffice")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t("cash")))]),_vm._v(" "),_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("189.00")])]),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('td',{staticClass:"text-left",attrs:{"colspan":"2"}},[_c('strong',[_vm._v(_vm._s(_vm.$t("total")))])]),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24)])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"white-wrapper"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h5',[_vm._v(_vm._s(_vm.$t("dailySalesConcessionReport")))]),_vm._v(" "),(
          // getDailyReportList.length > 0 ||
          // getDailyConcessionReportList.length > 0 ||
          _vm.getConcessionDailyReportData.length > 0
        )?_c('div',{staticClass:"col-lg-6 col-xl-6 align-self-center mb-3 d-flex justify-content-end align-items-center"},[(
            // getDailyReportList.length > 0 ||
            // getDailyConcessionReportList.length > 0 ||
            _vm.getConcessionDailyReportData.length > 0
          )?_c('div',[_vm._v(_vm._s(_vm.$t("download"))+" as:")]):_vm._e(),_vm._v(" "),(_vm.getConcessionDailyPdfFileName)?_c('a',{attrs:{"href":_vm.BASE_URL + _vm.getConcessionDailyPdfFileName,"target":"_blank","download":"","title":"Download as PDF"}},[_c('img',{attrs:{"src":require("@/assets/img/icons/pdf-icon.svg"),"height":"25","width":"25"}})]):_vm._e(),_vm._v(" "),(_vm.getConcessionDailyExcelFileName)?_c('a',{attrs:{"href":_vm.BASE_URL + _vm.getConcessionDailyExcelFileName,"target":"_blank","title":"Download as Excel","download":""}},[_c('img',{attrs:{"src":require("@/assets/img/icons/excel.svg"),"height":"25","width":"25"}})]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"swc-report"},[_c('table',{staticClass:"swc-report swc-report-table dailysales_report",staticStyle:{"table-layout":"'auto'"},attrs:{"border":"1"}},[_c('thead',{staticClass:"bg-lightgrey"},[_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v(_vm._s("Channel"))]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("User")]),_vm._v(" "),_c('th',{staticClass:"p-0"},[_c('table',{staticClass:"fixed-layout-table table-elements-border"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v("Item")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("PayType")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Voucher")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Qty")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Cash")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("CreditCard")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Voucher Amt")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("CashCard")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Total Sale")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_c('span',{staticClass:"fs-12"},[_vm._v(_vm._s("Total Sales"))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"fs-10 text-truncate"},[_vm._v(_vm._s("(Less discount)"))])])])])])])])]),_vm._v(" "),(
            _vm.getConcessionDailyReportData &&
              _vm.getConcessionDailyReportData.length == 0
          )?_c('tbody',[_c('tr',{attrs:{"rowspan":"12"}},[_c('td',{attrs:{"colspan":"12"}},[_c('NoRecords')],1)])]):(
            _vm.getConcessionDailyReportData &&
              _vm.getConcessionDailyReportData.length > 0
          )?_c('tbody',{staticClass:"sph-report"},_vm._l((_vm.getConcessionDailyReportData),function(ConcessionItem,ConcessionIndex){return _c('tr',{key:ConcessionIndex},[_c('td',{staticClass:"text-left"},[_vm._v("\n              "+_vm._s(ConcessionItem.FnbItems[0].paymentTypes[0].fst_booking_source)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v("\n              "+_vm._s(ConcessionItem.FnbItems[0].paymentTypes[0].username)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"child-tables dailysales_report",attrs:{"colspan":"10"}},_vm._l((ConcessionItem.FnbItems),function(FnbItem,FnbItemIndex){return _c('table',{key:FnbItemIndex,staticClass:"fixed-layout-table border",attrs:{"border":"1"}},[_c('tbody',[_vm._l((FnbItem.paymentTypes),function(PaymentItem,PaymentIndex){return _c('tr',{key:PaymentIndex},[_c('td',{staticClass:"text-left"},[_vm._v("\n                      "+_vm._s(PaymentIndex == 0 ? PaymentItem.fst_item_name : "")+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v("\n                      "+_vm._s(PaymentItem.fst_payment_mode)+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v("\n                      "+_vm._s(PaymentItem.ft_voucher_name ||
                          PaymentItem.ft_offer_name ||
                          "-")+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(PaymentItem.total_quantity)+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.currFormat(PaymentItem.cash_amount))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.currFormat(PaymentItem.payment_mode_amount))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.currFormat(PaymentItem["ft_offer_price"]))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.currFormat(PaymentItem.cash_card_amount))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.currFormat(PaymentItem.total_amount))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.currFormat(PaymentItem["balance_amount"]))+"\n                    ")])])}),_vm._v(" "),(
                      FnbItem.hasOwnProperty('DataRefund') &&
                        FnbItem.DataRefund.length > 0
                    )?_c('tr',{staticStyle:{"background-color":"rgba(246, 194, 188, 0.5)"}},[_c('td',{staticClass:"text-left",attrs:{"colspan":"10"}},[_vm._v("\n                      Refund\n                    ")])]):_vm._e(),_vm._v(" "),_vm._l((FnbItem.DataRefund),function(PaymentItem,PaymentIndex){return (
                      FnbItem.hasOwnProperty('DataRefund') &&
                        FnbItem.DataRefund.length > 0
                    )?_c('tr',{key:PaymentIndex},[_c('td',{staticClass:"text-left"}),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(PaymentItem.payment_mode))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s("-"))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(PaymentItem.items > 0 ? "-" + PaymentItem.items : 0)+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.currFormat(
                          _vm.getNegativeValue(PaymentItem.cash_amount_refund)
                        ))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.currFormat(
                          _vm.getNegativeValue(
                            PaymentItem.payment_mode_amount_refund
                          )
                        ))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.currFormat(0)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.currFormat(
                          _vm.getNegativeValue(PaymentItem.cash_card_refund)
                        ))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.currFormat(_vm.getNegativeValue(PaymentItem.total_refund)))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.currFormat(
                          _vm.getNegativeValue(PaymentItem["total_refund"])
                        ))+"\n                    ")])]):_vm._e()}),_vm._v(" "),(
                      FnbItem.hasOwnProperty('DataRefund') &&
                        FnbItem.DataRefund.length > 0
                    )?_c('tr',{staticStyle:{"background-color":"rgba(211, 211, 211, 0.4)"}},[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v(_vm._s(_vm.$tc("refund", 1))+" "+_vm._s(_vm.$t("total")))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(FnbItem.DataRefund.reduce(function(
                          accumulator,
                          ref
                        ) {
                          var items = ref.items;

                          return accumulator + parseFloat(items);
                        },
                        0) > 0
                          ? "-" +
                            FnbItem.DataRefund.reduce(function(
                              accumulator,
                              ref
                            ) {
                              var items = ref.items;

                              return accumulator + parseFloat(items);
                            },
                            0)
                          : FnbItem.DataRefund.reduce(function(
                              accumulator,
                              ref
                            ) {
                              var items = ref.items;

                              return accumulator + parseFloat(items);
                            },
                            0)))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                          _vm.getNegativeValue(
                            FnbItem.DataRefund.reduce(function(
                              accumulator,
                              ref
                            ) {
                              var cash_amount_refund = ref.cash_amount_refund;

                              return (
                                accumulator + parseFloat(cash_amount_refund)
                              );
                            },
                            0) > 0
                              ? FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var cash_amount_refund = ref.cash_amount_refund;

                                  return (
                                    accumulator +
                                    parseFloat(cash_amount_refund)
                                  );
                                },
                                0)
                              : FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var cash_amount_refund = ref.cash_amount_refund;

                                  return (
                                    accumulator +
                                    parseFloat(cash_amount_refund)
                                  );
                                },
                                0)
                          )
                        )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                          _vm.getNegativeValue(
                            FnbItem.DataRefund.reduce(function(
                              accumulator,
                              ref
                            ) {
                              var payment_mode_amount_refund = ref.payment_mode_amount_refund;

                              return (
                                accumulator +
                                parseFloat(payment_mode_amount_refund)
                              );
                            },
                            0) > 0
                              ? FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var payment_mode_amount_refund = ref.payment_mode_amount_refund;

                                  return (
                                    accumulator +
                                    parseFloat(payment_mode_amount_refund)
                                  );
                                },
                                0)
                              : FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var payment_mode_amount_refund = ref.payment_mode_amount_refund;

                                  return (
                                    accumulator +
                                    parseFloat(payment_mode_amount_refund)
                                  );
                                },
                                0)
                          )
                        )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(0)))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                          _vm.getNegativeValue(
                            FnbItem.DataRefund.reduce(function(
                              accumulator,
                              ref
                            ) {
                              var cash_card_refund = ref.cash_card_refund;

                              return (
                                accumulator + parseFloat(cash_card_refund)
                              );
                            },
                            0) > 0
                              ? FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var cash_card_refund = ref.cash_card_refund;

                                  return (
                                    accumulator + parseFloat(cash_card_refund)
                                  );
                                },
                                0)
                              : FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var cash_card_refund = ref.cash_card_refund;

                                  return (
                                    accumulator + parseFloat(cash_card_refund)
                                  );
                                },
                                0)
                          )
                        )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                          _vm.getNegativeValue(
                            FnbItem.DataRefund.reduce(function(
                              accumulator,
                              ref
                            ) {
                              var total_refund = ref.total_refund;

                              return accumulator + parseFloat(total_refund);
                            },
                            0) > 0
                              ? FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var total_refund = ref.total_refund;

                                  return (
                                    accumulator + parseFloat(total_refund)
                                  );
                                },
                                0)
                              : FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var total_refund = ref.total_refund;

                                  return (
                                    accumulator + parseFloat(total_refund)
                                  );
                                },
                                0)
                          )
                        )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                          _vm.getNegativeValue(
                            FnbItem.DataRefund.reduce(function(
                              accumulator,
                              ref
                            ) {
                              var total_refund = ref.total_refund;

                              return accumulator + parseFloat(total_refund);
                            },
                            0) > 0
                              ? FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var total_refund = ref.total_refund;

                                  return (
                                    accumulator + parseFloat(total_refund)
                                  );
                                },
                                0)
                              : FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var total_refund = ref.total_refund;

                                  return (
                                    accumulator + parseFloat(total_refund)
                                  );
                                },
                                0)
                          )
                        )))])])]):_vm._e(),_vm._v(" "),_c('tr',{staticStyle:{"background-color":"rgba(169, 217, 251, 0.5)"}},[_c('td',{staticClass:"text-left"},[_c('strong',[_vm._v(_vm._s(_vm.$t("total")))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(FnbItem.DataRefund
                          ? FnbItem.paymentTypes.reduce(function(
                              accumulator,
                              ref
                            ) {
                              var total_quantity = ref.total_quantity;

                              return accumulator + parseFloat(total_quantity);
                            },
                            0) -
                            FnbItem.DataRefund.reduce(function(
                              accumulator,
                              ref
                            ) {
                              var items = ref.items;

                              return accumulator + parseFloat(items);
                            },
                            0)
                          : FnbItem.paymentTypes.reduce(function(
                              accumulator,
                              ref
                            ) {
                              var total_quantity = ref.total_quantity;

                              return accumulator + parseFloat(total_quantity);
                            },
                            0)))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                          FnbItem.DataRefund
                            ? FnbItem.paymentTypes.reduce(function(
                                accumulator,
                                ref
                              ) {
                                var cash_amount = ref.cash_amount;

                                return accumulator + parseFloat(cash_amount);
                              },
                              0) -
                                FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var cash_amount_refund = ref.cash_amount_refund;

                                  return (
                                    accumulator +
                                    parseFloat(cash_amount_refund)
                                  );
                                },
                                0)
                            : FnbItem.paymentTypes.reduce(function(
                                accumulator,
                                ref
                              ) {
                                var cash_amount = ref.cash_amount;

                                return accumulator + parseFloat(cash_amount);
                              },
                              0)
                        )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                          FnbItem.DataRefund
                            ? FnbItem.paymentTypes.reduce(function(
                                accumulator,
                                ref
                              ) {
                                var payment_mode_amount = ref.payment_mode_amount;

                                return (
                                  accumulator +
                                  parseFloat(payment_mode_amount)
                                );
                              },
                              0) -
                                FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var payment_mode_amount_refund = ref.payment_mode_amount_refund;

                                  return (
                                    accumulator +
                                    parseFloat(payment_mode_amount_refund)
                                  );
                                },
                                0)
                            : FnbItem.paymentTypes.reduce(function(
                                accumulator,
                                ref
                              ) {
                                var payment_mode_amount = ref.payment_mode_amount;

                                return (
                                  accumulator +
                                  parseFloat(payment_mode_amount)
                                );
                              },
                              0)
                        )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                          FnbItem.DataRefund
                            ? FnbItem.paymentTypes.reduce(function(
                                accumulator,
                                ref
                              ) {
                                var ft_offer_price = ref.ft_offer_price;

                                return (
                                  accumulator + parseFloat(ft_offer_price)
                                );
                              },
                              0) -
                                FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var ft_offer_price = ref.ft_offer_price;

                                  return (
                                    accumulator + parseFloat(ft_offer_price)
                                  );
                                },
                                0)
                            : FnbItem.paymentTypes.reduce(function(
                                accumulator,
                                ref
                              ) {
                                var ft_offer_price = ref.ft_offer_price;

                                return (
                                  accumulator + parseFloat(ft_offer_price)
                                );
                              },
                              0)
                        )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                          FnbItem.DataRefund
                            ? FnbItem.paymentTypes.reduce(function(
                                accumulator,
                                ref
                              ) {
                                var cash_card_amount = ref.cash_card_amount;

                                return (
                                  accumulator + parseFloat(cash_card_amount)
                                );
                              },
                              0) -
                                FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var cash_card_refund = ref.cash_card_refund;

                                  return (
                                    accumulator + parseFloat(cash_card_refund)
                                  );
                                },
                                0)
                            : FnbItem.paymentTypes.reduce(function(
                                accumulator,
                                ref
                              ) {
                                var cash_card_amount = ref.cash_card_amount;

                                return (
                                  accumulator + parseFloat(cash_card_amount)
                                );
                              },
                              0)
                        )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                          FnbItem.DataRefund
                            ? FnbItem.paymentTypes.reduce(function(
                                accumulator,
                                ref
                              ) {
                                var total_amount = ref.total_amount;

                                return accumulator + parseFloat(total_amount);
                              },
                              0) -
                                FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var total_refund = ref.total_refund;

                                  return (
                                    accumulator + parseFloat(total_refund)
                                  );
                                },
                                0)
                            : FnbItem.paymentTypes.reduce(function(
                                accumulator,
                                ref
                              ) {
                                var total_amount = ref.total_amount;

                                return accumulator + parseFloat(total_amount);
                              },
                              0)
                        )))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(
                          FnbItem.DataRefund
                            ? FnbItem.paymentTypes.reduce(function(
                                accumulator,
                                ref
                              ) {
                                var balance_amount = ref.balance_amount;

                                return (
                                  accumulator + parseFloat(balance_amount)
                                );
                              },
                              0) -
                                FnbItem.DataRefund.reduce(function(
                                  accumulator,
                                  ref
                                ) {
                                  var total_refund = ref.total_refund;

                                  return (
                                    accumulator + parseFloat(total_refund)
                                  );
                                },
                                0)
                            : FnbItem.paymentTypes.reduce(function(
                                accumulator,
                                ref
                              ) {
                                var balance_amount = ref.balance_amount;

                                return (
                                  accumulator + parseFloat(balance_amount)
                                );
                              },
                              0)
                        )))])])])],2)])}),0)])}),0):_vm._e(),_vm._v(" "),(_vm.getConcessionDailyReportData.length > 0)?_c('tbody',[_c('tr',[_c('td',{staticClass:"bg-lightgrey text-left",attrs:{"colspan":"2"}},[_c('strong',[_vm._v(_vm._s(_vm.$t("grand"))+" "+_vm._s(_vm.$t("total")))])]),_vm._v(" "),_c('td',{staticClass:"p-0"},[_c('table',{staticClass:"fixed-layout-table table-elements-border border",attrs:{"border":"1"}},[_c('thead',[_c('tr',[_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_c('td',{staticClass:"bg-lightgrey text-right"},[_c('strong',[_vm._v(_vm._s(_vm.getGrandTotalNew.totalQuantity))])]),_vm._v(" "),_c('td',{staticClass:"bg-lightgrey text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(_vm.getGrandTotalNew.totalCashAmount)))])]),_vm._v(" "),_c('td',{staticClass:"bg-lightgrey text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(_vm.getGrandTotalNew.totalPaymentModeAmount)))])]),_vm._v(" "),_c('td',{staticClass:"bg-lightgrey text-right"},[_c('strong',{attrs:{"getGrandTotalNew.totalDiscount":""}},[_vm._v(_vm._s(_vm.currFormat(_vm.getGrandTotalNew.totalDiscount)))])]),_vm._v(" "),_c('td',{staticClass:"bg-lightgrey text-right"},[_c('strong',[_vm._v(_vm._s(_vm.currFormat(_vm.getGrandTotalNew.totalCashCardAmount)))])]),_vm._v(" "),_c('td',{staticClass:"bg-lightgrey text-right"},[(_vm.getGrandTotalNew.totalRevenue)?_c('strong',[_vm._v(_vm._s(_vm.currFormat(_vm.getGrandTotalNew.totalRevenue)))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"bg-lightgrey text-right"},[_c('strong',{attrs:{"getGrandTotalNew.totalBalance":""}},[_vm._v(_vm._s(_vm.currFormat(_vm.getGrandTotalNew.totalBalance)))])])])])])])])]):_vm._e()])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"cardDetails","title":"Cash Cards","hide-footer":"","hide-header":""}},[_c('div',{},[(_vm.showCardListNew.length > 0)?_c('table',{staticClass:"list-view-table border m-0"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$tc("card"))+" "+_vm._s(_vm.$tc("number")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$tc("customer"))+" "+_vm._s(_vm.$tc("name")))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_c('span',{},[_vm._v(_vm._s(_vm.$tc("status", 2)))])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.showCardListNew),function(card,key){return _c('tr',{key:key},[_c('td',[_vm._v(_vm._s(card.cash_card_number || "-"))]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(card.customer_name ? card.customer_name : "Street Sale")+"\n            ")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"d-flex align-items-center justify-content-end mr-4"},[_c('StatusDot',{attrs:{"status":card.cash_card_is_active === 'Y'
                      ? 'active'
                      : card.cash_card_is_active === 'N' && 'inactive'}})],1)])])}),0)]):_vm._e()])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"bg-lightgrey"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"bg-lightgrey"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"bg-lightgrey"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2"},[_c('p',{staticClass:"light-title"},[_vm._v("Outlet")]),_vm._v(" "),_c('p',{staticClass:"total-dark"},[_vm._v("0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2"},[_c('p',{staticClass:"light-title"},[_vm._v("Username")]),_vm._v(" "),_c('p',{staticClass:"total-dark"},[_vm._v("0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2"},[_c('p',{staticClass:"light-title"},[_vm._v("Item")]),_vm._v(" "),_c('p',{staticClass:"total-dark"},[_vm._v("0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2"},[_c('p',{staticClass:"light-title"},[_vm._v("Payment Type")]),_vm._v(" "),_c('p',{staticClass:"total-dark"},[_vm._v("0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2"},[_c('p',{staticClass:"light-title"},[_vm._v("Offer")]),_vm._v(" "),_c('p',{staticClass:"total-dark"},[_vm._v("0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2"},[_c('p',{staticClass:"light-title"},[_vm._v("Quantity")]),_vm._v(" "),_c('p',{staticClass:"total-dark"},[_vm._v("0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('hr',{staticClass:"my-2"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2"},[_c('p',{staticClass:"light-title"},[_vm._v("Gross Revenue")]),_vm._v(" "),_c('p',{staticClass:"total-dark"},[_vm._v("0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2"},[_c('p',{staticClass:"light-title"},[_vm._v("Net Revenue")]),_vm._v(" "),_c('p',{staticClass:"total-dark"},[_vm._v("0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2"},[_c('p',{staticClass:"light-title"},[_vm._v("Discount")]),_vm._v(" "),_c('p',{staticClass:"total-dark"},[_vm._v("0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2"},[_c('p',{staticClass:"light-title"},[_vm._v("Balance")]),_vm._v(" "),_c('p',{staticClass:"total-dark"},[_vm._v("0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('hr',{staticClass:"my-2"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"8"}},[_vm._v("Refund of Cash against voucher")])]),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('th',{staticClass:"text-left"},[_vm._v("SR. No")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Outlet")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Name Of Voucher")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Type Of voucher")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Gross Value of Voucher")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Consumed Valued")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Refund Value")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Payment Type")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"7"}},[_vm._v("Sale of Cash Card")])]),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('th',{staticClass:"text-left"},[_vm._v("SR. No")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Issuer")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("No of Cash Card")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Value Per Cash Card")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Processing Fee")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Payment Type")]),_vm._v(" "),_c('th',{},[_vm._v("View Cash Card List")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"3"}},[_vm._v("Topup Cash Card")])]),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey"},[_c('th',{staticClass:"text-left"},[_vm._v("SR. No")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Payment Mode")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Amount")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"colspan":"5"}},[_vm._v("Film Wise Summary")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("21")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-right"},[_c('strong',[_vm._v("787.77")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"bg-lightgrey"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"bg-lightgrey"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"bg-lightgrey"},[_c('strong')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27b17553","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/ReportsContainer/dailySalesReport-v2.vue
// module id = null
// module chunks = 